export const useProductPrice = () => {
  const productStore = useProductVariantsStore()

  return computed(() => {
    const activeVariant = productStore.activeVariant
    return activeVariant?.eCommerce?.price ?? undefined
  })
}
